import React from "react";
import Timesheet from "./Timesheet";
import AdjustmentRequest from "./AdjustmentRequest";
import LeaveRequest from "./LeaveRequest";

const ApprovalOutlet = ({ departmentname, departmentslug, employeeUname }) => {
    return (
        <div className="columns">
            <div className="column">
                <div className="approval timesheet">
                    <h3>Timesheet</h3>
                    <Timesheet departmentname={departmentname} departmentslug={departmentslug} employeeUname={employeeUname} />
                </div>
            </div>

            
            <div className="column">
                <div className="approval adjustment-request">
                    <h3>Adjustment Request</h3>
                    <AdjustmentRequest departmentname={departmentname} departmentslug={departmentslug} employeeUname={employeeUname} />
                </div>
            </div>

            
            <div className="column">
                <div className="approval leave-request">
                    <h3>Form Requests</h3>
                    <LeaveRequest departmentname={departmentname} departmentslug={departmentslug} employeeUname={employeeUname} />
                </div>
            </div>
        </div>
    )
}

export default ApprovalOutlet;